export const extractDefinedProps = <T extends {}>(sourceObject: T): Partial<T> => {
  const definedObject: Partial<T> = {};
  
  for (const key in sourceObject) {
    if (sourceObject[key] !== undefined) definedObject[key] = sourceObject[key];
  }

  return definedObject;
};
